<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-money'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
  [widgetDisabled]="false"
  (clicked)="openProductsModal()"
></app-kpi-widget>
